export const useDownloadExample = () => {
  const downloadExample = () => {
    const headers = [
      "name",
      "description",
      "combinator",
      "field_id_1",
      "field_value_1",
      "field_operator_1",
      "field_id_2",
      "field_value_2",
      "field_operator_2",
      "field_id_3",
      "field_value_3",
      "field_operator_3",
      "field_id_4",
      "field_value_4",
      "field_operator_4",
      "field_id_5",
      "field_value_5",
      "field_operator_5",
    ];
    const rows = [
      [
        "Group test 1",
        "Group 1 test description",
        "and",
        "ec9e6f02-2451-4469-a781-31a6b34df075",
        "Manager|Engineer|Designer",
        "is",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    ];

    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "example-groups.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return { downloadExample };
};
